// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import { rfqQuoteDetailsSalesRepProductListStyles } from "@awc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { hideElement, mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsSalesRepProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

rfqQuoteDetailsSalesRepProductListStyles.productImage = {
    ...mergeWithCss(cartLineSharedStyles.productImage, {
        linkWrappingImage: {
            css: css`
                ${xScreen("lte", "sm")} {
                    width: 114px;
                    height: 114px;
                }
            `,
        },
    }),
};

rfqQuoteDetailsSalesRepProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingStyles = {
    row: {
        mergeCss: true,
        evenRowCss: css`
            background: transparent;
        `,
        css: css`
            border: none;
        `,
    },
    quantityCell: {
        css: css`
            border: none;
            height: 18px;
            vertical-align: top;
            padding: 0 8px 0 0;
            display: flex;
            align-items: baseline;
        `,
    },
    priceCell: {
        css: css`
            border: none;
            height: 18px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    priceWithoutVatCell: {
        css: css`
            border: none;
            height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.uomHeadingAndText = {
    heading: {
        weight: "bold",
        size: 12,
        css: css`
            ${hideElement}
        `,
    },
    text: {
        css: css`
            padding-left: 6px;
            white-space: nowrap;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingContainer = {
    css: css`
        display: flex;
        align-items: baseline;
        padding-top: 3px;
        > div {
            display: inline-block;
            width: auto;
        }
        > div:first-child {
            display: inline-block;
            width: auto;
            max-width: 140px;
        }

        ${xScreen("lte", "md")} {
            > div:first-child {
                display: inline-block;
                width: auto;
                max-width: 100%;
            }
        }
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.buttonContainer = {
    css: css`
        display: flex;
        justify-content: flex-end;
        button {
            min-height: 32px;
        }
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 2fr 5fr 2fr 1fr 1fr;
            ${xScreen("lte", "lg")} {
                grid-template-columns: 2fr 5fr 2fr 1fr 1fr;
            }
            ${xScreen("lte", "md")} {
                grid-template-columns: 1fr 5fr 2fr;
                row-gap: 0;
            }
        `,
    },
    image: {
        css: css`
            display: flex;
            justify-content: center;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 2;
                grid-row: 1 / 5;
            }
        `,
    },
    description: {
        css: css`
            grid-column: 2 / 3;
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 1 / 2;
            }
        `,
    },
    price: {
        css: css`
            grid-column: 3/4;
            grid-row: 1/2;
            ${xScreen("lte", "md")} {
                grid-column: 2 / 3;
                grid-row: 2 / 3;
                text-align: right;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 2 / 3;
                text-align: left;
            }
        `,
    },
    qty: {
        css: css`
            grid-column: 4/5;
            grid-row: 1/2;
            text-align: left;
            ${xScreen("lte", "md")} {
                grid-column: 2 / 3;
                grid-row: 2 / 3;
                text-align: right;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 3 / 4;
                text-align: left;
            }
        `,
    },
    total: {
        css: css`
            grid-column: 5/6;
            grid-row: 1/2;
            ${xScreen("lte", "md")} {
                grid-column: 3 / 4;
                grid-row: 2 / 3;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2/4;
                grid-row: 4 / 5;
            }
        `,
    },
    notes: {
        css: css`
            grid-column: 2/3;
            grid-row: 2/3;
            ${xScreen("lte", "md")} {
                grid-row: 3/4;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 1/4;
                grid-row: 5/6;
            }
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.linesHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 2fr 5fr 2fr 1fr 1fr;
        `,
    },
    itemDescription: {
        css: css`
            padding-left: 12px;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quoteLineButton = {};

rfqQuoteDetailsSalesRepProductListStyles.qtyOrderedField = {
    qtyLabel: {
        color: "secondary",
        lineHeight: fontConfig.lineHeight.small,
        css: css`
            display: none;
            ${xScreen("lte", "md")} {
                display: inline-block;
            }
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.mainWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            margin-top: 16px;
        }
    `,
};
